import React from 'react'

const ELEMENT_ID = 'divToPrint'

const PAGE_W = 794
const PAD_H = 40
const PAD_V = 56

const ROOT_STYLE = {
  width: `${PAGE_W}px`,
  boxSizing: 'border-box',
  padding: `${PAD_H}px ${PAD_V}px`,
  fontFamily: 'Times New Roman, serif',
  fontSize: '13pt',
  lineHeight: '1.5',
  color: '#000',
  backgroundColor: '#fff',
}

const col2 = { display: 'table', width: '100%', tableLayout: 'fixed' }
const cell = {
  display: 'table-cell',
  verticalAlign: 'top',
  textAlign: 'center',
}

/**
 * Template ẩn — chỉ render HTML với id="divToPrint".
 * Caller tự gọi renderElementToPdfFile('divToPrint', fileName) khi cần.
 *
 * Props:
 *  feedbackDetailData  {object}  – dữ liệu phiếu
 *  selectedIndex       {number}  – id comment đang chọn
 *  selectedOption      {string}  – 'AGREE' | 'DISAGREE' | 'OTHER'
 *  comment             {string}  – ý kiến bổ sung (HTML string)
 */
const ExportPdf = ({
  feedbackDetailData,
  selectedIndex,
  selectedOption,
  comment = '',
}) => {
  const { legalBasis, feedbackComments } = feedbackDetailData

  const documentNumberValue =
    (feedbackDetailData &&
      (feedbackDetailData.documentNumber ||
        feedbackDetailData.document_number)) ||
    ''

  const contentData = feedbackComments?.find(
    item => item.id === Number(selectedIndex)
  )

  const today = new Date()
  const dateStr = `Hà Nội, ngày ${today.getDate()} tháng ${
    today.getMonth() + 1
  } năm ${today.getFullYear()}`

  const checkboxSrc = checked =>
    `${window.location.protocol}//${window.location.host}/assets/icons/${
      checked ? 'checkedbox' : 'uncheckedbox'
    }.PNG`

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        zIndex: -1,
        visibility: 'hidden',
      }}>
      <div id={ELEMENT_ID} style={ROOT_STYLE}>
        {/* ── 1. Header ── */}
        <div style={col2}>
          <div style={cell}>
            <strong>CÔNG TY CP VIMC LOGISTICS</strong>
            <div>---------------------</div>
            <div>
              {documentNumberValue
                ? `Số: ${
                    String(documentNumberValue).includes('/')
                      ? documentNumberValue
                      : `${documentNumberValue}/PLYK-HĐQT`
                  }`
                : 'Số: -'}
            </div>
          </div>
          <div style={cell}>
            <strong style={{ whiteSpace: 'nowrap' }}>
              CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
            </strong>
            <div>
              <strong>Độc lập - Tự do - Hạnh phúc</strong>
            </div>
            <div>---------------------</div>
            <div>
              <em>{dateStr}</em>
            </div>
          </div>
        </div>

        {/* ── 2. Title ── */}
        <div style={{ textAlign: 'center', margin: '18px 0 6px' }}>
          <strong style={{ fontSize: '13pt' }}>PHIẾU XIN Ý KIẾN</strong>
        </div>
        <div style={{ textAlign: 'center', marginBottom: '14px' }}>
          Kính gửi: Thành viên HĐQT Công ty cổ phần VIMC Logistics
        </div>

        {/* ── 3. Căn cứ ── */}
        <div style={{ marginBottom: '4px' }}>
          <strong>Căn cứ:</strong>
        </div>
        <div
          style={{ textAlign: 'justify', marginBottom: '12px' }}
          dangerouslySetInnerHTML={{ __html: legalBasis ?? '' }}
        />

        {/* ── 4. Nội dung lấy ý kiến ── */}
        <div style={{ marginBottom: '4px' }}>
          <strong>Nội dung lấy ý kiến:</strong>
        </div>
        <div
          style={{ textAlign: 'justify', marginBottom: '8px' }}
          dangerouslySetInnerHTML={{ __html: contentData?.content ?? '' }}
        />

        {/* ── 5. Ghi chú ── */}
        <div style={{ textAlign: 'justify', marginBottom: '28px' }}>
          <strong>Ghi chú:</strong> Các thành viên HĐQT không có ý kiến có thể
          cho ý kiến trực tiếp trên Phiếu lấy ý kiến này hoặc gửi ý kiến đính
          kèm theo Phiếu.
        </div>

        {/* ── 6. Chữ ký Chủ tịch HĐQT ── */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            marginBottom: '8px',
            paddingRight: '60px',
          }}>
          <div>
            <strong>CHỦ TỊCH HĐQT</strong>
          </div>

          <div style={{ marginTop: '60px', fontSize: '13pt' }}>
            <strong>Nguyễn Đình Chung</strong>
          </div>
        </div>

        {/* ── 7. Tiêu đề phần ý kiến thành viên ── */}
        <div
          style={{
            textAlign: 'left',
            fontWeight: 'bold',
          }}>
          ______________________________________________________________________________
        </div>

        <div
          style={{
            textAlign: 'left',
            fontWeight: 'bold',
            marginBottom: '12px',
          }}>
          Ý kiến của thành viên HĐQT:
        </div>

        {/* ── 8. Checkbox biểu quyết ── */}
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '24px',
          }}>
          <tbody>
            <tr>
              {[
                { label: 'TÁN THÀNH', value: 'AGREE' },
                { label: 'KHÔNG TÁN THÀNH', value: 'DISAGREE' },
                { label: 'KHÔNG CÓ Ý KIẾN', value: 'OTHER' },
              ].map(({ label, value }) => (
                <td
                  key={value}
                  style={{
                    border: 'none',
                    textAlign: 'center',
                    paddingBottom: '4px',
                  }}>
                  <span style={{ marginRight: '6px', fontWeight: 500 }}>
                    {label}:
                  </span>
                  <img
                    src={checkboxSrc(selectedOption === value)}
                    alt={label}
                    style={{
                      width: '20px',
                      height: '16px',
                      verticalAlign: 'middle',
                    }}
                  />
                </td>
              ))}
            </tr>
          </tbody>
        </table>

        {comment ? (
          <div style={{ marginBottom: '16px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Ý kiến:</div>
            <div
              style={{ textAlign: 'justify' }}
              dangerouslySetInnerHTML={{ __html: comment }}
            />
          </div>
        ) : null}

        <div>
          ______________________________________________________________________________
        </div>
        {/* ── 10. Chữ ký thành viên HĐQT ── */}
        <div>
          <div
            style={{
              display: 'inline-block',
              paddingTop: '4px',
              marginTop: '0px',
            }}>
            <strong>Thành viên HĐQT</strong>
            <div>
              <em>(Ký và ghi rõ họ tên)</em>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExportPdf
